import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

function Toggle({
  value,
  loading,
  toggleId,
  isToggled,
  onToggledSwitch,
}) {
  const containerStyle = clsx({
    'Toggle': true,
    'Toggle--active': isToggled,
    'Toggle--loading': loading,
  })

  const iconStyle = clsx({
    'Toggle__icon': true,
    'Toggle__icon--active': isToggled,
    'Toggle__icon--loading': loading,
  })

  return (
    <div id={toggleId} className={containerStyle} onClick={()=> onToggledSwitch(value)}>
      <div className={iconStyle}>
      </div>
    </div>
  )
}

Toggle.propTypes = {
  value: PropTypes.any,
  loading: PropTypes.bool,
  toggleId: PropTypes.string,
  isToggled: PropTypes.bool,
  onToggledSwitch: PropTypes.func,
}

export default Toggle
